import { MenuPopper as Root, inplaceString, type MenuPopperProps } from './MenuPopper';
import { MenuPopperInput } from './MenuPopperInput';

export { type MenuPopperProps };
export const MenuPopper = Object.assign(Root, {
  Input: MenuPopperInput,
  inplaceString
});
